<template>
  <auth>
    <div class="social">
      <p>Get started by signing in below</p>
      <ul>
        <li>
          <g-signin-button
            :params="googleSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError"
          >
            <span class="icon" /> Sign in with Google
          </g-signin-button>
        </li>
      </ul>
    </div>
    <div class="auth">
      <div v-html="$error.handle(error)" />
      <form @submit.prevent="register">
        <br>
        <h4>Register</h4>
        <hr>
        <div class="form-group">
          <label for="username">Email</label>
          <input
            id="username"
            v-model="user.email"
            type="text"
            class="form-control"
            required=""
          >
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="user.password"
            type="password"
            class="form-control"
            required=""
          >
        </div>
        <div class="form-group">
          <label for="password_confirmation">Confirm Password</label>
          <input
            id="password_confirmation"
            v-model="user.password_confirmation"
            type="password"
            class="form-control"
            required=""
          >
        </div>
        <div class="form-group">
          <button class="btn btn-primary">
            Register
          </button>
        </div>
        <div class="forgot">
          <router-link
            class="link"
            :to="{name: 'login'}"
          >
            Have an account? Sign In.
          </router-link>
        </div>
      </form>
    </div>
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },
        data() {
            return {
                user: {
                    email: '',
                    password: '',
                    access_token: ''
                },
                error: '',
                googleSignInParams: {
                    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
                }
            }
        },
        computed: {
            loggeduser() {
                return this.$store.getters.getAuthUser;
            },
        },
        methods: {
            register() {
                this.$axios.post('/api/v1/register', this.user).then(() => {
                    this.$auth.setVerifyUser(this.user.email);
                    window.location.href = this.$router.resolve({name: 'register.confirm'}).href;
                }).catch(error => {
                    this.error = error.response;
                });
            },
            onSignInSuccess(googleUser) {
                const profile = googleUser.getBasicProfile();
                this.email = profile.getEmail();
                let auth = googleUser.getAuthResponse(true);
                this.access_token = auth.access_token;
                this.googleLogin();
            },
            onSignInError() {
                this.error = {status: 401, data: {message: 'Google sign in failed'}};
            },
            googleLogin() {
                let self = this;
                this.$axios.post("api/v1/auth/google", {
                    access_token: self.access_token
                }).then((response) => {
                    this.navigateLogin(response.data);
                }).catch(() => {
                    this.error = {status: 401, data: {message: 'Could not register you in at this time'}};
                });
            },
            navigateLogin(data) {
                this.$auth.setToken(data.access_token);
                this.$axios.defaults.headers.Authorization = 'Bearer ' + this.$auth.getToken();
                this.$store.dispatch('setAuthUser', data).then(() => {
                    if (this.loggeduser.requires_password_change) {
                        this.$router.replace({name: 'set-password'});
                        return;
                    }

                    if (this.loggeduser.id_number == null && !this.loggeduser.create_by_admin) {
                        this.$router.replace({name: 'verify.personal'});
                        return;
                    }

                    if (!this.loggeduser.verified_phone && this.loggeduser.id_number !== null) {
                        this.$router.replace({name: 'verify.phone'});
                        return;
                    }

                    if (this.loggeduser.verified_phone) {
                        this.$router.replace({name: 'dashboard'});
                    }
                });
            },
        }
    }
</script>
